import type {ReactElement} from 'react';
import {VersionListItem} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editor-version-history-panel/components/version-history-list-item/version-list-item';
import {VersionHistoryListSkeleton} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editor-version-history-panel/components/version-history-list-skeleton/version-history-list-skeleton';
import styles from './version-history-list.module.scss';
import type {PosterVersionData} from '@Components/poster-editor/library/poster-editor-library';

export interface VersionHistoryListProps {
  versions: PosterVersionData[];
  selectedIndex: number;
  loadingVersionIndex: number | null;
  isInitialLoading: boolean;
  onVersionSelect: (index: number) => Promise<void>;
}

export function VersionHistoryList({versions, selectedIndex, loadingVersionIndex, isInitialLoading, onVersionSelect}: VersionHistoryListProps): ReactElement {
  if (isInitialLoading) {
    return <VersionHistoryListSkeleton/>;
  }

  return (
    <ul className={`flexbox flex-column-justify-start flex-items-stretch ${styles.versionHistoryList}`}>
      {versions.map((version, index) => (
        <VersionListItem
          key={version.versionId}
          version={version}
          index={index}
          isSelected={index === selectedIndex}
          isLoading={loadingVersionIndex === index}
          onVersionSelect={onVersionSelect}
        />
      ))}
    </ul>
  );
}
